import React, {useEffect, useRef} from 'react'
import {useCountUp} from 'react-countup'
import {Text} from '@eggplant-finance/eggplant-uikit-theme'
import styled from "styled-components";

interface CardValueProps {
    value: number
    decimals?: number
    fontSize?: string
    prefix?: string
    noDependencies?: boolean
}

const ModiText = styled(Text)`
  color: ${({theme}) => theme.isDark ? '#e8e2fb' : '#460a80'}
`;

const ModiTextNoDependencies = styled(Text)`
  color: ${({theme}) => theme.isDark ? '#8e81b8' : '#000'}
`

const CardValue: React.FC<CardValueProps> = ({value, decimals, fontSize = '40px', prefix, noDependencies}) => {
    const {countUp, update} = useCountUp({
        start: 0,
        end: value,
        duration: 1,
        separator: ',',
        decimals:
        // eslint-disable-next-line no-nested-ternary
            decimals !== undefined ? decimals : value < 0 ? 4 : value > 1e5 ? 0 : 3,
    })

    const updateValue = useRef(update)

    useEffect(() => {
        updateValue.current(value)
    }, [value, updateValue])

    return (

        noDependencies ?
            <ModiTextNoDependencies bold  fontSize={fontSize}>
                {prefix}
                {countUp}
            </ModiTextNoDependencies>
            :
            <ModiText bold fontSize={fontSize} >
                {prefix}
                {countUp}
            </ModiText>

    )
}

export default CardValue
